import { meQueryOptions } from "@/api/auth";
import { api, auth, queryClient } from "@/api/utils";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ cause }) => {
    if (cause !== "enter") {
      return;
    }
    if (auth.hasAccessToken()) {
      return;
    }
    try {
      await auth.renewAuthTokens(true);
      await api.auth.getMarketplaceUserInfo();
    } catch (e) {}
  },
  loader: () => {
    queryClient.prefetchQuery(meQueryOptions);
  },
  pendingComponent: Outlet,
});
